/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierStarterMaxStaffSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_STARTER_MAX_STAFF')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class TierStarterMaxStaffSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierStarterMaxStaffSettingParser.decode(input).map(res => new TierStarterMaxStaffSetting(res));
    }
    static unsafeDecode(input) {
        return TierStarterMaxStaffSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierStarterMaxStaffSettingParser.encode(data);
    }
    static schema() {
        return TierStarterMaxStaffSettingParser.schema();
    }
}
